import { ApplicationTypeEnum } from '@legacy/shared-types/enums/application-type.enum';
import { ProductRangeEnum } from '@legacy/shared-types/enums/product-range-type.enum';
import { ProductTypeEnum } from '@legacy/shared-types/enums/product-type.enum';

export enum ResultsTabsEnum {
  results = 'results',
  summary = 'summary',
}

export interface FormattedCalculatorResult {
  applicationType: ApplicationTypeEnum;
  description: string;
  equityShare: number;
  fee: number;
  id: number;
  initialBaseRate: number;
  initialMargin: number;
  initialRate: number;
  isActive: boolean;
  ltv: number;
  margin: number;
  maxFinancing: number;
  maximumFTV: number;
  monthsInitial: number;
  productFees: number;
  productRange: ProductRangeEnum;
  productType: ProductTypeEnum;
  repayments: number;
  requestedFinance: number;
  reversionRate: number;
  salesforceId: number;
  term: number;
}

export type ExtendedFormattedCalculatorResult = FormattedCalculatorResult & {
  maximumPossible?: FormattedCalculatorResult | null;
};
